import { DtoId } from '../base.dto';

export enum AssetCategory {
  DEBIT_ACCOUNTS = 'DEBIT_ACCOUNTS',
  RESIDENTIAL_REAL_ESTATE = 'RESIDENTIAL_REAL_ESTATE',
  COMMERCIAL_REAL_ESTATE = 'COMMERCIAL_REAL_ESTATE',
  LAND = 'LAND',
  LEGAL_ENTITIES = 'LEGAL_ENTITIES',
  JEWELLERY = 'JEWELLERY',
  BANK_CELLS = 'BANK_CELLS',
  METAL_ACCOUNTS = 'METAL_ACCOUNTS',
  CENTRALIZED_WALLET = 'CENTRALIZED_WALLET',
  DECENTRALIZED_WALLET = 'DECENTRALIZED_WALLET',
  PRECIOUS_STONES = 'PRECIOUS_STONES',
  COMMODITY_ASSET_TOKENS = 'COMMODITY_ASSET_TOKENS',
  BROKERAGE_ACCOUNT = 'BROKERAGE_ACCOUNT',
  SECURITIES_AND_STOCKS = 'SECURITIES_AND_STOCKS',
  BONDS = 'BONDS',
  EXCHANGE_OPTIONS = 'EXCHANGE_OPTIONS',
  OVER_THE_COUNTER_OPTIONS = 'OVER_THE_COUNTER_OPTIONS',
  FORWARDS = 'FORWARDS',
  FUTURES = 'FUTURES',
  MY_FUND = 'MY_FUND',
  PUBLIC_FUND = 'PUBLIC_FUND',
}

export type CoOwner = {
  coOwnerEntityDtoId?: DtoId;
  coOwnerDocument: DtoId[];
  coOwnerShare: number;
};

// TODO move to enums
export enum AssetStatus {
  NEW = 'NEW',
  INCOMPLETE = 'INCOMPLETE',
  FILLED = 'FILLED',
}
export enum AssetsType {
  MOVABLE = 'MOVABLE',
  IMMOVABLE = 'IMMOVABLE',
  CRYPTO = 'CRYPTO',
}
export enum ActivityType {
  active = 'active',
  passive = 'passive',
}
export enum InvestmentsGoalsType {
  investment = 'investment',
  personal = 'personal',
  saving = 'saving',
}

export enum PerspectivesType {
  sell = 'sell',
  onHold = 'onHold',
  develop = 'develop',
}
export enum HighMediumLowType {
  high = 'high',
  medium = 'medium',
  low = 'low',
}
export enum ETaxBurden {
  HIGH = 'hign',
  MEDIUM = 'medium',
  LOW = 'low',
  NO = 'no',
}
export enum TaxAgentType {
  client = 'client',
  bank = 'bank',
  other = 'other',
}
export enum LegalEntityTaxAgentType {
  client = 'client',
  legalEntity = 'legalEntity',
  other = 'other',
}
export enum HolderTaxAgentType {
  client = 'client',
  financialInstitution = 'financialInstitution',
  other = 'other',
}
export enum OwnershipType {
  DIRECT = 'DIRECT',
  INDIRECT = 'INDIRECT',
  // JOINT = 'JOINT',
}
export enum DisclosureType {
  yes = 'yes',
  done = 'done',
  no = 'no',
  inProcess = 'inProcess',
}
export enum PublicFundTaxAgentType {
  investor = 'investor',
  fund = 'fund',
  other = 'other',
}
export enum TaxAgentWithBrokerType {
  client = 'client',
  broker = 'broker',
  other = 'other',
}

export type CurrencyValue = {
  value?: number;
  from?: string;
};
